import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaForeign } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { toast } from 'react-toastify';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import {
  transformRequestMunicipalityForeign,
  transformResponseMunicipalityEditForeign,
} from 'system/geographic/utils/transformer-municipality-edit';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const MunicipalityEditPage = (): React.ReactElement => {
  const params = useParams();

  const updateMunicipality = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/straniero`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
    },
  });

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEditForeign,
    }
  );

  const municipality = municipalityData.data as MunicipalityForm;

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityForm | undefined) => {
      const data = transformRequestMunicipalityForeign(formValues);
      (
        updateMunicipality({
          url: `/${formValues?.code}`,
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [updateMunicipality, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Modifica Comune Estero' }]} />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipality
          title="Modifica Comune Estero"
          onOk={onSubmit}
          isForeign
          isEdit
          validationSchema={validationSchemaForeign}
          initialValues={municipality}
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityEditPage.displayName = 'Municipality edit page component';

export default MunicipalityEditPage;
